var IREP = IREP || {};

IREP.Recon = (function () {
    var defaultOptions = {
        clearanceLevel: 0,
        clearanceTextSpeed: 80,
        doorSpeed: 1000,
        introRingCount: 4,
        experiencePoints: 0,
        experienceLevel: 0,
        tway: {
            selectedPosition: 0,
            selectedMap: [],
            maps: {
                easy: [[
                    "TWAY-3DOT_EasyMaps_0001_Quiz1-UT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0002_Quiz1-UT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0003_Quiz1-UT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0004_Quiz1-UT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0005_Quiz2-DT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0006_Quiz2-DT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0007_Quiz2-DT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0008_Quiz2-DT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0009_Quiz3-UT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0010_Quiz3-UT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0011_Quiz3-UT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0012_Quiz3-UT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0013_Quiz4-DT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0014_Quiz4-DT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0015_Quiz4-DT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0016_Quiz4-DT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0017_Quiz5-UT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0018_Quiz5-UT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0019_Quiz5-UT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0020_Quiz5-UT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0021_Quiz6-DT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0022_Quiz6-DT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0023_Quiz6-DT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0024_Quiz6-DT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0025_Quiz7-UT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0026_Quiz7-UT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0027_Quiz7-UT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0028_Quiz7-UT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0029_Quiz8-DT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0030_Quiz8-DT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0031_Quiz8-DT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0032_Quiz8-DT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0033_Quiz9-UT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0034_Quiz9-UT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0035_Quiz9-UT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0036_Quiz9-UT-3.jpg"
                ], [
                    "TWAY-3DOT_EasyMaps_0037_Quiz10-DT-0.jpg",
                    "TWAY-3DOT_EasyMaps_0038_Quiz10-DT-1.jpg",
                    "TWAY-3DOT_EasyMaps_0039_Quiz10-DT-2.jpg",
                    "TWAY-3DOT_EasyMaps_0040_Quiz10-DT-3.jpg"
                ]],
                standard: [[
                    "INTEL-TWAY MAP-V2_0001_Quiz1-UT-0.jpg",
                    "INTEL-TWAY MAP-V2_0002_Quiz1-UT-1.jpg",
                    "INTEL-TWAY MAP-V2_0003_Quiz1-UT-2.jpg",
                    "INTEL-TWAY MAP-V2_0004_Quiz1-UT-3.jpg",
                    "INTEL-TWAY MAP-V2_0005_Quiz1-UT-4.jpg",
                    "INTEL-TWAY MAP-V2_0006_Quiz1-UT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0007_Quiz2-DT-0.jpg",
                    "INTEL-TWAY MAP-V2_0008_Quiz2-DT-1.jpg",
                    "INTEL-TWAY MAP-V2_0009_Quiz2-DT-2.jpg",
                    "INTEL-TWAY MAP-V2_0010_Quiz2-DT-3.jpg",
                    "INTEL-TWAY MAP-V2_0011_Quiz2-DT-4.jpg",
                    "INTEL-TWAY MAP-V2_0012_Quiz2-DT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0013_Quiz3-UT-0.jpg",
                    "INTEL-TWAY MAP-V2_0014_Quiz3-UT-1.jpg",
                    "INTEL-TWAY MAP-V2_0015_Quiz3-UT-2.jpg",
                    "INTEL-TWAY MAP-V2_0016_Quiz3-UT-3.jpg",
                    "INTEL-TWAY MAP-V2_0017_Quiz3-UT-4.jpg",
                    "INTEL-TWAY MAP-V2_0018_Quiz3-UT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0019_Quiz4-DT-0.jpg",
                    "INTEL-TWAY MAP-V2_0020_Quiz4-DT-1.jpg",
                    "INTEL-TWAY MAP-V2_0021_Quiz4-DT-2.jpg",
                    "INTEL-TWAY MAP-V2_0022_Quiz4-DT-3.jpg",
                    "INTEL-TWAY MAP-V2_0023_Quiz4-DT-4.jpg",
                    "INTEL-TWAY MAP-V2_0024_Quiz4-DT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0025_Quiz5-UT-0.jpg",
                    "INTEL-TWAY MAP-V2_0026_Quiz5-UT-1.jpg",
                    "INTEL-TWAY MAP-V2_0027_Quiz5-UT-2.jpg",
                    "INTEL-TWAY MAP-V2_0028_Quiz5-UT-3.jpg",
                    "INTEL-TWAY MAP-V2_0029_Quiz5-UT-4.jpg",
                    "INTEL-TWAY MAP-V2_0030_Quiz5-UT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0031_Quiz6-DT-0.jpg",
                    "INTEL-TWAY MAP-V2_0032_Quiz6-DT-1.jpg",
                    "INTEL-TWAY MAP-V2_0033_Quiz6-DT-2.jpg",
                    "INTEL-TWAY MAP-V2_0034_Quiz6-DT-3.jpg",
                    "INTEL-TWAY MAP-V2_0035_Quiz6-DT-4.jpg",
                    "INTEL-TWAY MAP-V2_0036_Quiz6-DT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0037_Quiz7-UT-0.jpg",
                    "INTEL-TWAY MAP-V2_0038_Quiz7-UT-1.jpg",
                    "INTEL-TWAY MAP-V2_0039_Quiz7-UT-2.jpg",
                    "INTEL-TWAY MAP-V2_0040_Quiz7-UT-3.jpg",
                    "INTEL-TWAY MAP-V2_0041_Quiz7-UT-4.jpg",
                    "INTEL-TWAY MAP-V2_0042_Quiz7-UT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0043_Quiz8-DT-0.jpg",
                    "INTEL-TWAY MAP-V2_0044_Quiz8-DT-1.jpg",
                    "INTEL-TWAY MAP-V2_0045_Quiz8-DT-2.jpg",
                    "INTEL-TWAY MAP-V2_0046_Quiz8-DT-3.jpg",
                    "INTEL-TWAY MAP-V2_0047_Quiz8-DT-4.jpg",
                    "INTEL-TWAY MAP-V2_0048_Quiz8-DT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0049_Quiz9-UT-0.jpg",
                    "INTEL-TWAY MAP-V2_0050_Quiz9-UT-1.jpg",
                    "INTEL-TWAY MAP-V2_0051_Quiz9-UT-2.jpg",
                    "INTEL-TWAY MAP-V2_0052_Quiz9-UT-3.jpg",
                    "INTEL-TWAY MAP-V2_0053_Quiz9-UT-4.jpg",
                    "INTEL-TWAY MAP-V2_0054_Quiz9-UT-5.jpg",
                ], [
                    "INTEL-TWAY MAP-V2_0055_Quiz10-DT-0.jpg",
                    "INTEL-TWAY MAP-V2_0056_Quiz10-DT-1.jpg",
                    "INTEL-TWAY MAP-V2_0057_Quiz10-DT-2.jpg",
                    "INTEL-TWAY MAP-V2_0058_Quiz10-DT-3.jpg",
                    "INTEL-TWAY MAP-V2_0059_Quiz10-DT-4.jpg",
                    "INTEL-TWAY MAP-V2_0060_Quiz10-DT-5.jpg",
                ]]
            }
        },
        countdownTime: 60,
        crackTheCode: {
            characters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567890".split(''),
            words: [
                "ULTRABOOK", "THREADING", "INTEL", "KNOWLEDGE", "CORE", "GREAT", "POWER", "STRUGGLE",
                "NETWORK", "OPERATIONS", "EXPERIENCE"
            ],
            threeWordMessages: [
                ["Locate", "the", "Tap"],
                ["Capture", "the", "Traitors"],
                ["Locate", "Stolen", "Tech"],
                ["Darkness", "Is", "Safe"],
                ["Power", "Is", "Regulated"],
                ["Advance", "and", "Report"],
                ["End", "the", "Incursion"],
                ["Eliminate", "the", "Resistance"]
            ],
            fiveWordMessages: [
                ["The", "Sheep", "Must", "Be", "Controlled"],
                ["Collect", "Taxes", "from", "the", "Merchants"],
                ["Deploy", "Regulators", "to", "Sapo", "Square"],
                ["Enforce", "All", "Unregulated", "Power", "Usage"],
                ["Let", "Them", "Fight", "Each", "Other"],
                ["They", "Are", "Mere", "Stepping", "Stones"],
                ["The", "Overlord", "Controls", "the", "Power"],
                ["The", "Resistance", "Shall", "Be", "Squashed"],
                ["The", "Commonwealth", "Is", "No", "More"]
            ],
            passMessage: ["  DECODED   "],
            failMessage: [" INCOMPLETE "]
        },
        locateTheEnemy: {
            pieces: [[
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0002_Map 3A-Uptown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0003_Map 4A-Location-Stacks.jpg",
                    "content/images/swic5/locate/Game Pieces_0004_Map-5A-Stacks.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0002_Map 3A-Uptown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0005_Map 4A-Mansion.jpg",
                    "content/images/swic5/locate/Game Pieces_0006_Map 5A-Mansion.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0002_Map 3A-Uptown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0007_Map 4A-Warehouse.jpg",
                    "content/images/swic5/locate/Game Pieces_0008_Map5A-Warehouse.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0009_Map 3B-Midtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0010_Map 4B-Apartment.jpg",
                    "content/images/swic5/locate/Game Pieces_0011_Map 5B-Apartments.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0009_Map 3B-Midtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0012_Map 4B-PowerPlant1.jpg",
                    "content/images/swic5/locate/Game Pieces_0013_Map 5B-Power Plant 1.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0009_Map 3B-Midtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0014_Map 4B-Power Plant 2.jpg",
                    "content/images/swic5/locate/Game Pieces_0015_Map 5B-Power Plant2.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0009_Map 3B-Midtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0016_Map 4B-Subway2.jpg",
                    "content/images/swic5/locate/Game Pieces_0017_Map 5B-Subway.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0009_Map 3B-Midtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0016_Map 4B-Subway2.jpg",
                    "content/images/swic5/locate/Game Pieces_0018_Map 5B-Subway2.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0019_Map 3C-Downtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0020_Map 4C-Statue.jpg",
                    "content/images/swic5/locate/Game Pieces_0021_Map 5C-Statue.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0019_Map 3C-Downtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0022_Map 4C-Factory.jpg",
                    "content/images/swic5/locate/Game Pieces_0023_Map 5C-Factory.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0019_Map 3C-Downtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0024_Map 4C-Underground.jpg",
                    "content/images/swic5/locate/Game Pieces_0025_Map 5C-Underground.jpg"
            ], [
                    "content/images/swic5/locate/Game Pieces_0000_Map1-General Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0001_Map 2-Regional Location.jpg",
                    "content/images/swic5/locate/Game Pieces_0019_Map 3C-Downtown Sector.jpg",
                    "content/images/swic5/locate/Game Pieces_0026_Map 4C-Bowery.jpg",
                    "content/images/swic5/locate/Game Pieces_0027_Map 5C-Bowery.jpg"
            ]]
        }
    };

    var Recon = function (options) {
        if (!(this instanceof Recon)) {
            return new Recon();
        }

        var self = this;

        this.options = $.extend({}, defaultOptions, options);

        this.$currentPage = null;
        this.currentAudio = null;
        this.currentAudioDeferred = null;

        this.textTimeoutID = 0;

        this.countDown = null;
        this.quizContent = null;
        this.questionNumber = null;
        this.currentCountdownTime = this.options.countdownTime;

        this.clearanceText = "SECURITY CLEARANCE REQUIRED::: ";
        this.clearanceTimeoutID = 0;
        this.$clearance = $('#clearanceRequiredType');

        this.crackTimeoutID = 0;

        this.quizStartTime = 0;
        this.quizAnswerTime = 0;
        this.quizAnswers = [];

        this.resetGame();

        // use window load event as it is fired after images are loaded.
        $(window).on('load', function () {
            self.introStart();
        });

        $('.page.result .return').on('click', function () {
            self.clearanceStart();
        });

        $('.page.result .playAudio').on('click', function () {
            var audioFiles = [];
            if ($('.smallScreen').hasClass('pass')) {
                audioFiles = self.$currentPage.find('.pass:visible audio');
            } else {
                audioFiles = self.$currentPage.find('.fail:visible audio');
            }

            if (audioFiles.length > 0) {
                var audioFile = audioFiles[Math.floor(Math.random() * audioFiles.length)];
                self.playAudio(audioFile);
            }
        });
    };

    /************************************
     * Static variables
     ************************************/
    Recon.getTimestamp = function () {
        if (window.performance && window.performance.now) {
            return window.performance.now();
        } else {
            if (window.performance && window.performance.webkitNow) {
                return window.performance.webkitNow();
            } else {
                return new Date().getTime();
            }
        }
    };

    Recon.gameDefaults = {
        callbacks: {
            start: function () { },
            answer: function () { },
            stop: function () { },
            result: function () { },
            exit: function () { }
        }
    };

    /**********************************
     * Helper functions
     ***********************************/
    Recon.prototype.openDoor = function () {
        $('.door').animate({ top: '-155px' }, this.options.doorSpeed);
    };

    Recon.prototype.closeDoor = function () {
        $('.door').animate({ top: '0px' }, this.options.doorSpeed);
    };

    Recon.prototype.switchPage = function (page) {
        $('.page').hide();

        this.$currentPage = $(page);
        this.$currentPage.show();
    };

    Recon.prototype.playAudio = function (audio) {
        var deferred = $.Deferred();

        try {
            this.stopAudio();

            this.currentAudioDeferred = deferred;
            this.currentAudio = audio;

            this.currentAudio.onended = function () {
                deferred.resolve();
            };

            this.currentAudio.play();
        } catch(e) {
            deferred.resolve();
        }
        return deferred.promise();
    };

    Recon.prototype.stopAudio = function () {
        try {
            if (this.currentAudio != null) {
                this.currentAudio.pause();
                this.currentAudio.currentTime = 0;
                this.currentAudio = null;
                this.currentAudioDeferred = null;
            }
        } catch(e) {}
    };

    Recon.prototype.increaseProgressMeter = function () {
        var img = $('.progressMeter img[src$="lightsOff.png"]:first');
        if(img.length > 0) {
            var src = img.attr('src').replace('lightsOff.png', 'lightsOn.png');
            img.attr('src', src);
        }
    };

    Recon.prototype.getAvailableClearanceLevels = function () {
        return IREP.callApi({ url: 'swic5/clearancelevel/available', type: 'GET' });
    };

    Recon.prototype.getReconDetails = function () {
        return IREP.callApi({ url: 'swic5/recon/details', type: 'GET' });
    };

    Recon.prototype.slideOutLinks = function () {
        $('a.hq').animate({ left: '-190px' }, this.options.doorSpeed);
        $('a.leaderboard').animate({ right: '-192px' }, this.options.doorSpeed);
    };

    Recon.prototype.slideInLinks = function () {
        $('a.hq').animate({ left: '-30px' }, this.options.doorSpeed);
        $('a.leaderboard').animate({ right: '-30px' }, this.options.doorSpeed);
    };

    Recon.prototype.shuffle = function (array, rand) {
        var i = array.length, j, swap;
        if (!rand) rand = Math;
        while (--i) {
            j = rand.random() * (i + 1) | 0;
            swap = array[i];
            array[i] = array[j];
            array[j] = swap;
        }
        return array;
    };

    Recon.prototype.padRight = function (str, length, characters) {
        return str + Array(length - str.length + 1).join(characters || " ")
    }

    Recon.prototype.resetGame = function () {
        this.game = $.extend({}, Recon.gameDefaults);
    }

    Recon.prototype.typeText = function ($elem) {
        var self = this;
        var deferred = $.Deferred();

        var text = $elem.data('text');
        var textLength = text.length;
        var textPosition = 0;
        var textBuffer = "";

        $elem.show();
        (function type() {
            if (textPosition > textLength) {
                deferred.resolve();
                return;
            }

            nextChar = text.charAt(textPosition++);

            textBuffer = textBuffer + nextChar;
            $elem.html(textBuffer);

            self.textTimeoutID = setTimeout(type, self.options.clearanceTextSpeed);
        }());

        return deferred.promise();
    };

    Recon.prototype.delay = function (timeout) {
        var deferred = $.Deferred();

        setTimeout(function () {
            deferred.resolve();
        }, timeout);

        return deferred.promise();
    };

    Recon.prototype.updateExperiencePoints = function (experiencePoints) {
        this.options.experiencePoints = experiencePoints;

        if (experiencePoints < 500) {
            $('.expierenceMeter span').animate({ width: (experiencePoints / 500) * 160 }, 1000);
        } else {
            $('.expierenceMeter span').animate({ width: 160 }, 1000)
        }
    };

    Recon.prototype.updateExperienceLevel = function (experienceLevel) {
        if (this.options.experienceLevel === 0 && this.options.experienceLevel != experienceLevel) {
            $('.expierenceMeter img').attr('src', IREP.options.appUrl + 'content/images/swic5/recon/rank' + experienceLevel + '.png').fadeIn();
        } else if (this.options.experienceLevel !== 0 && this.options.experienceLevel != experienceLevel) {
            $('.expierenceMeter img').fadeOut().promise().done(function () {
                $('.expierenceMeter img').attr('src', IREP.options.appUrl + 'content/images/swic5/recon/rank' + experienceLevel + '.png').fadeIn();
            });
        }

        $('.smallScreen').attr('class', 'smallScreen');

        switch (experienceLevel) {
            case 0:
                $('.code h1').text('CRACK THE CODE');
                $('.smallScreen').addClass('crackTheCode');
                break;
            case 1:
                $('.code h1').text('LOCATE THE ENEMY');
                $('.smallScreen').addClass('locateTheEnemy');
                break;
            default:
                $('.code h1').text('MOVE THE FRONT LINE');
                $('.smallScreen').addClass('tway');
                break;
        }

        this.options.experienceLevel = experienceLevel;
    };

    Recon.prototype.updateProgressMeter = function (progressMeterCount) {
        var $lightsOn = $('.progressMeter img[src$="lightsOn.png"]');
        var todo = progressMeterCount - $lightsOn.length;
        if (todo > 0) {
            var $lightsOff = $('.progressMeter img[src$="lightsOff.png"]');
            for (var i = 0; i < todo && i < $lightsOff.length; i++) {
                var src = $($lightsOff[i]).attr('src').replace('lightsOff.png', 'lightsOn.png');
                $($lightsOff[i]).attr('src', src);
            }
        }
    };

    Recon.prototype.scrollTop = function () {
        $("html, body").animate({ scrollTop: 0 }, 0);
    };

    /***********************************************
     * TWay game
     ***********************************************/

    Recon.prototype.selectTWayMap = function () {
        this.options.tway.selectedPosition = 0;
        this.options.tway.selectedMap = Math.round(Math.random() * (this.options.tway.maps.length - 1));

        this.displayTWayMap();
    };

    Recon.prototype.displayTWayMap = function () {
        $('.tway img').attr('src', this.options.tway.maps[this.options.tway.selectedMap][this.options.tway.selectedPosition]);
    };

    Recon.prototype.displayNextTWayMap = function () {
        this.options.tway.selectedPosition++;

        this.displayTWayMap();
    };

    /*****************************************
     * Intro page 
     *****************************************/
    Recon.prototype.introStart = function () {
        var self = this;
        var done = false;

        var click = function () {
            //$(this).off(click);
            done = true;
            self.introStop();
        }

        this.switchPage('#intro');
        $('#recon').addClass('showCursor');

        if ($('#mobileAppContainer').length === 0) {
            this.playAudio(self.$currentPage.find('.shortWave')[0]).then(function () {
                return self.playAudio(self.$currentPage.find('.modem')[0]);
            }).then(function () {
                return self.typeText(self.$currentPage.find('.established'));
            }).then(function() {
                return self.delay(2000);
            }).then(function () {
                return self.typeText(self.$currentPage.find('.required'));
            }).then(function () {
                return self.delay(2000);
            }).done(function () {
                $('#contentContainer, #mobileAppContainer').off('click', click);
                if (!done) {
                    self.introStop();
                }
            })

            this.introAddRings();
        } else {
            self.typeText(self.$currentPage.find('.established')).then(function () {
                return self.delay(2000);
            }).then(function () {
                return self.typeText(self.$currentPage.find('.required'));
            }).then(function () {
                return self.delay(2000);
            }).done(function () {
                $('#contentContainer, #mobileAppContainer').off('click', click);
                if (!done) {
                    self.introStop();
                }
            });
        }

        $('#contentContainer, #mobileAppContainer').one('click', click);
    };

    Recon.prototype.introStop = function () {
        this.stopAudio();

        $('#recon').removeClass('showCursor');

        this.clearanceStart();
    };

    Recon.prototype.introAddRings = function () {
        var self = this;

        var src = $('.ring').data('src');
        var ring = $('<img/>', { src: src });
        $('.ring').append(ring);
        
        ring.animate({
            width: 1200,
            height: 1200,
            top: -410,
            left: -242,
            opacity: 0
        }, {
            duration: 12000,
            progress: function (a, b, c) {
                if (b >= .15 && $(this).data('spawn') == null && self.$currentPage.attr('id') === 'intro') {
                    self.introAddRings();
                    $(this).data('spawn', 1);
                }
            },
            done: function () {
                $(this).hide();
                $(this).remove();
            }
        });
    };

    Recon.prototype.introTextStart = function () {
        var self = this;
        var maxLength = 80;
        var textLength = this.clearanceText.length;
        var textPosition = 0;
        var textBuffer = "";

        (function type() {
            if (textPosition > textLength) {
                textPosition = 0;
            }

            nextChar = self.clearanceText.charAt(textPosition++);

            textBuffer = textBuffer + nextChar;
            if (maxLength != 0 && textBuffer.length > maxLength) {
                textBuffer = textBuffer.slice(1, textBuffer.length);
            }

            self.$clearance.html(textBuffer);

            self.clearanceTimeoutID = setTimeout(type, self.options.clearanceTextSpeed);
        }());
    };

    Recon.prototype.introTextStop = function () {
        clearTimeout(this.clearanceTimeoutID);
    };

    /***********************************
     * Clearance selection page
     ***********************************/
    Recon.prototype.clearanceStart = function () {
        var self = this;

        this.closeDoor();
        this.slideInLinks();
        
        this.clearanceUpdateReconDetails().done(function() {
            self.switchPage('#clearance');
        });

        $('#clearance').find('ul').off().one('click', 'li', function () {
            self.options.clearanceLevel = $(this).data('clearance-level');

            self.quizStart(self.options.clearanceLevel);
        });
    };

    Recon.prototype.clearanceStop = function () {

    };

    Recon.prototype.clearanceUpdateReconDetails = function () {
        var self = this;

        return this.getReconDetails().done(function (response) {
            self.clearanceUpdateLevels(response.clearanceLevels);
            self.updateExperiencePoints(response.experiencePoints);
            self.updateExperienceLevel(response.experienceLevel);
            self.updateProgressMeter(response.progressMeterCount);
        });
    };

    Recon.prototype.clearanceUpdateLevels = function (clearanceLevels) {
        var $clearanceLevels = $('#clearance ul');
        $clearanceLevels.empty();
        $.each(clearanceLevels, function (i, e) {
            var $li = $('<li/>', { text: e.name, data: { 'clearance-level': e.level } });
            $clearanceLevels.append($li);
        });

        if (clearanceLevels.length === 0) {
            $clearanceLevels.hide();
            $('#clearance .doneForDay').show();
            $('#clearance :not(.doneForDay):not(h1)').hide();
        }
    };

    /****************************************
     * Quiz page, where the fun goes
     ****************************************/
    Recon.prototype.quizGetTime = function () {
        return Math.round(((Recon.getTimestamp() - this.quizStartTime)) / 1000, 0);
    };

    Recon.prototype.quizStart = function (clearanceLevel) {
        var self = this;

        switch (this.options.experienceLevel) {
            case 0:
                this.crackSetup();
                break;
            case 1:
                this.locateSetup();
                break;
            default:
                this.twaySetup();
                break;
        }

        self.scrollTop();
        self.switchPage('#blank');
        this.quizGetClearanceContent(clearanceLevel).done(function (response) {
            self.questionNumber = 0;
            self.quizAnswers = [];
            self.quizStartTime = Recon.getTimestamp();
            self.quizAnswerTime = self.quizGetTime();
            self.quizContent = response.content;
            self.currentCountdownTime = self.options.countdownTime;
            self.switchPage('#quiz');

            self.$currentPage.find('.countdownTime').html(self.options.countdownTime);
            self.quizDisplayNextQuestion();

            self.countDown = new IREP.Countdown({ updateTime: 1000, totalTime: self.options.countdownTime * 1000 });
            self.countDown.start().progress(function (timings) {
                self.$currentPage.find('.countdownTime').html(timings.remaining / 1000);
            }).done(function (timings) {
                self.quizStop(timings);
            }).fail(function (timings) {
                self.quizStop(timings);
            });

            self.openDoor();
            self.slideOutLinks();
            self.game.callbacks.start.call(self);
        }).fail(function() {
            self.clearanceStart();
        });
    };

    Recon.prototype.quizGetClearanceContent = function (clearanceLevel) {
        return IREP.callApi({ url: 'swic5/quiz', data: { clearanceLevel: clearanceLevel } });
    };

    Recon.prototype.quizDisplayNextQuestion = function () {
        var question = this.quizContent.questions[this.questionNumber];

        if (question != null) {
            this.$currentPage.find('.question').html(question.questionText);
            this.quizDisplayAnswers();

            this.questionNumber++;
        } else {
            this.countDown.stop();
        }
    };

    Recon.prototype.quizDisplayAnswers = function () {
        var self = this;

        var question = this.quizContent.questions[this.questionNumber];
        var $answers = this.$currentPage.find('.answers');
        $answers.empty();

        $.each(question.answers, function (i, e) {
            var $li = $('<li/>', { html: e.answerText, data: { 'answer-id': e.answerId, 'question-id': question.questionId } });
            $answers.append($li);
        })

        $answers.off().one('click', 'li', function () {
            var questionId = $(this).data('question-id');
            var answerId = $(this).data('answer-id');
            if (answerId != null) {
                self.quizSelectAnswer(questionId, answerId);
            }
        });
    };

    Recon.prototype.quizSelectAnswer = function (questionId, answerId) {
        this.quizLogAudit(answerId);
        this.quizAnswers.push({ questionId: questionId, answerId: answerId });
        this.quizDisplayNextQuestion();
        this.game.callbacks.answer.call(self);
    };

    Recon.prototype.quizLogAudit = function (answerId) {
        var currentTime = this.quizGetTime();
        var answerTime = currentTime - this.quizAnswerTime;
        this.quizAnswerTime = currentTime;

        var data = { "auditUID": this.quizContent.auditUID, "answerId": answerId, "answerTime": answerTime };
        return IREP.callApi({ url: 'swic5/audit/answer', type: 'POST', data: data });
    };

    Recon.prototype.quizStop = function (timings) {
        var self = this;

        this.game.callbacks.stop.call(self);
        var questions = [].concat(this.quizContent.questions);
        var unanswered = [].concat(questions.splice(this.quizAnswers.length, questions.length - this.quizAnswers.length));

        $.each(unanswered, function (i, e) {
            self.quizAnswers.push({ questionId: e.questionId, answerId: 0 });
        });

        this.switchPage('#calculating');
        this.quizSubmitAnswers(timings.elapsed / 1000).done(function (data) {
            self.increaseProgressMeter();

            self.game.callbacks.result.call(self, data);
        }).fail(function () {
            self.clearanceStart();
        });
    };

    Recon.prototype.quizSubmitAnswers = function (time) {
        var data = {
            activityUID: this.quizContent.activityUID,
            auditUID: this.quizContent.auditUID,
            time: time,
            results: this.quizAnswers
        };

        return IREP.callApi({ url: 'swic5/quiz', type: 'POST', data: data });
    };

    /******************************
     * Crack the Code
     ******************************/
    Recon.prototype.crackSetup = function () {
        var self = this;

        $('.smallScreen').removeClass('pass').removeClass('fail');
        $('#crackTheCodeResult h2 ~ p').remove();

        this.game = $.extend(true, {}, Recon.gameDefaults, {
            callbacks: {
                start: this.crackStart,
                stop: this.crackStop,
                result: this.crackResult
            }
        })
    };

    Recon.prototype.crackStart = function() {
        this.crackUpdateLettersRandomly();
    };

    Recon.prototype.crackStop = function() {
        
    };

    Recon.prototype.crackResult = function (result) {
        this.switchPage('#crackTheCodeResult');

        this.$currentPage.find('.right').text(result.right);
        this.$currentPage.find('.total').text(result.total);
        this.$currentPage.find('.seconds').text(result.seconds);

        this.$currentPage.find('.pass,.fail').hide();

        var messages = [];
        var message = [];

        if (result.clearanceLevel === 2) {
            messages = this.options.crackTheCode.threeWordMessages;
        } else {
            messages = this.options.crackTheCode.fiveWordMessages;
        }

        message = [].concat(messages[Math.floor(Math.random() * messages.length)]);

        var numberWrong = this.quizContent.questions.length - result.right;
        numberWrong = Math.min(message.length, numberWrong);

        var numbers = [];
        for (var i = 0; i < message.length; ++i) {
            numbers.push(i);
        }
        this.shuffle(numbers);

        for (var i = 0; i < numberWrong; i++) {
            var word = message[numbers[i]];

            for (var l = 0; l < word.length; l++) {
                word = word.replace(word[l], '*');
            }

            message[numbers[i]] = word;
        }

        $.each(message, function (i, e) {
            var $p = $('<p/>', { text: e });
            $p.insertBefore('#crackTheCodeResult h2 ~ div');
        });
        

        if (result.pass) {
            $('.smallScreen').addClass('pass');
            this.crackUpdateLettersToWord(this.options.crackTheCode.passMessage, true);

            var passMessages = this.$currentPage.find('p.pass');
            $(passMessages[Math.floor(Math.random() * passMessages.length)]).show();
        } else {
            $('.smallScreen').addClass('fail');
            this.crackUpdateLettersToWord(this.options.crackTheCode.failMessage, true);

            var failMessages = this.$currentPage.find('p.fail');
            $(failMessages[Math.floor(Math.random() * failMessages.length)]).show();
        }
    };

    Recon.prototype.crackUpdateLettersRandomly = function () {
        var self = this;
        clearTimeout(this.crackTimeoutID);

        var $letters = $('.letter');
        $.each($letters, function (i, e) {
            var chars = self.options.crackTheCode.characters.slice(0);
            var char = chars[Math.floor(Math.random() * chars.length)];
            $(e).text(char);
        });

        self.crackTimeoutID = setTimeout(function () {
            self.crackUpdateLettersRandomly();
        }, 100);
    };

    Recon.prototype.crackUpdateLettersToWord = function (word, once) {
        var self = this;
        clearTimeout(this.crackTimeoutID);

        var letters = [];
        if (word == null) {
            word = this.options.crackTheCode.words[Math.floor(Math.random() * this.options.crackTheCode.words.length)];
        }

        word = this.padRight(word, 12)

        if (once == null) {
            once = false;
        }

        var $letters = $('.letter');
        
        $.each($letters, function (index, e) {
            var chars = self.options.crackTheCode.characters.slice(0);
            arr = self.shuffle(chars);
            letters[index] = { found: false, letters: arr };
        });

        this.crackTimeoutID = setTimeout(function updateWord() {
            $.each($letters, function (index, e) {
                var obj = letters[index];
                if (obj.found === false) {
                    var char = obj.letters.pop();
                    $(e).text(char);
                    if (char === word[index]) {
                        obj.found = true;
                    }
                }
            });

            var left = $.grep(letters, function (e, i) {
                return e.found === false
            });

            if (left.length > 0) {
                self.crackTimeoutID = setTimeout(updateWord, 100);
            } else if(once === false) {
                self.crackTimeoutID = setTimeout(function () {
                    self.crackUpdateLettersToWord()
                }, 5000)
            }

        }, 100);

        var currentLetters = letters[$letters.length - 1];
    };

    /****************************
     * Locate the enemy
     ***************************/
    Recon.prototype.locateSetup = function () {
        this.game = $.extend(true, {}, Recon.gameDefaults, {
            callbacks: {
                start: this.locateStart,
                stop: this.locateStop,
                result: this.locateResult
            }
        })
    };

    Recon.prototype.locateStop = function () {

    };

    Recon.prototype.locateStart = function () {
        $('.smallScreen img').css('opacity', '1');
        $($('.smallScreen img')[4]).attr('src', IREP.options.appUrl + this.options.locateTheEnemy.pieces[0][0]);
    };

    Recon.prototype.locateResult = function (result) {
        var self = this;

        this.switchPage('#locateTheEnemyResult');

        this.$currentPage.find('.located, .notLocated').hide();
        this.$currentPage.find('.right').text(result.right);
        this.$currentPage.find('.total').text(result.total);
        this.$currentPage.find('.seconds').text(result.seconds);

        this.$currentPage.find('.pass,.fail').hide();

        var pieces = [].concat(this.options.locateTheEnemy.pieces[Math.floor(Math.random() * this.options.locateTheEnemy.pieces.length)]);

        var $imgs = $('.smallScreen img');

        $($imgs[4]).attr('src', IREP.options.appUrl + pieces[0]);
        $($imgs[3]).attr('src', IREP.options.appUrl + pieces[1]);
        $($imgs[2]).attr('src', IREP.options.appUrl + pieces[2]);
        $($imgs[1]).attr('src', IREP.options.appUrl + pieces[3]);
        $($imgs[0]).attr('src', IREP.options.appUrl + pieces[4]);

        var moves = Math.floor(result.right / result.total * pieces.length);
        var current = 4;

        if (moves > 0) {
            moves--;
            $($imgs[4]).animate({ opacity: 0 }, 2000).promise().then(function () {
                moves--;
                if (moves > 0) {
                    return $($imgs[3]).animate({ opacity: 0 }, 2000).promise()
                }
            }).then(function () {
                moves--;
                if (moves > 0) {
                    return $($imgs[2]).animate({ opacity: 0 }, 2000).promise()
                }
            }).then(function () {
                moves--;
                if (moves > 0) {
                    return $($imgs[1]).animate({ opacity: 0 }, 2000).promise()
                }
            });
        }

        if (result.pass) {
            this.$currentPage.find('.located').show();
            $('.smallScreen').addClass('pass');
            this.crackUpdateLettersToWord(this.options.crackTheCode.passMessage, true);

            var passMessages = this.$currentPage.find('p.pass');
            $(passMessages[Math.floor(Math.random() * passMessages.length)]).show();
        } else {
            this.$currentPage.find('.notLocated').show();
            $('.smallScreen').addClass('fail');
            this.crackUpdateLettersToWord(this.options.crackTheCode.failMessage, true);

            var failMessages = this.$currentPage.find('p.fail');
            $(failMessages[Math.floor(Math.random() * failMessages.length)]).show();
        }
    };

    /******************************
     * T-Way? This-Way? That-Way? There-Way?
     ******************************/
    Recon.prototype.twaySetup = function () {
        this.game = $.extend(true, {}, Recon.gameDefaults, {
            callbacks: {
                start: this.twayStart,
                stop: this.twayStop,
                result: this.twayResult
            }
        });
    };

    Recon.prototype.twayStart = function () {
        var self = this;

        switch (this.options.clearanceLevel) {
            case 2:
                this.options.tway.selectedMap = [].concat(this.options.tway.maps.easy[Math.floor(Math.random() * this.options.tway.maps.easy.length)])
                break;
            default:
                this.options.tway.selectedMap = [].concat(this.options.tway.maps.standard[Math.floor(Math.random() * this.options.tway.maps.standard.length)])
                break;
        };

        $('.smallScreen .imgPlate').empty();
        $.each(this.options.tway.selectedMap, function (i, e) {
            var $img = $('<img/>', { src: '/content/images/asmo/2014swic5/tway/' + e, css: { display: i == 0 ? 'block' : 'none' } });
            $('.smallScreen .imgPlate').append($img);
        });
    };

    Recon.prototype.twayStop = function () {

    };

    Recon.prototype.twayResult = function (result) {
        var self = this;

        this.switchPage('#twayResult');

        this.$currentPage.find('.located, .notLocated').hide();
        this.$currentPage.find('.right').text(result.right);
        this.$currentPage.find('.total').text(result.total);
        this.$currentPage.find('.seconds').text(result.seconds);

        this.$currentPage.find('.pass,.fail').hide();

        var moves = Math.floor(result.right / result.total * this.options.tway.selectedMap.length);
        (function fadeInStep(moves) {
            if (moves == 0) {
                return;
            }
            $($('.smallScreen .imgPlate img:hidden')[0]).fadeIn(2000, function () {
                fadeInStep(--moves);
            })
        }(moves))
        

        if (result.pass) {
            this.$currentPage.find('.located').show();
            $('.smallScreen').addClass('pass');
            this.crackUpdateLettersToWord(this.options.crackTheCode.passMessage, true);

            var passMessages = this.$currentPage.find('p.pass');
            $(passMessages[Math.floor(Math.random() * passMessages.length)]).show();
        } else {
            this.$currentPage.find('.notLocated').show();
            $('.smallScreen').addClass('fail');
            this.crackUpdateLettersToWord(this.options.crackTheCode.failMessage, true);

            var failMessages = this.$currentPage.find('p.fail');
            $(failMessages[Math.floor(Math.random() * failMessages.length)]).show();
        }
    };

    return Recon;
}());